export const EDIT_PROFILE = 'EDIT_PROFILE';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const RESET_PROFILE_FLAG = 'RESET_PROFILE_FLAG';
export const GET_USER = 'GET_USER';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';
export const SET_PROFILE_PICTURE = 'SET_PROFILE_PICTURE';
export const ACCOUNT_STATUS = 'ACCOUNT_STATUS';
